export enum ParticipantAdmissionStatusValues {
  NotMarked = "NOT_MARKED",
  Admitted = "ADMITTED",
  Rejected = "REJECTED",
}

export type ParticipantAdmissionStatus = ParticipantAdmissionStatusValues;
